import { Link } from "react-router-dom";
import { useSeo } from "../hooks/useSeo";
import { CircledArrow, Roundel } from "../components/brand/icons";

export default function NotFoundPage() {
  useSeo({ title: "Page not found | Pantheon Art", noindex: true });

  return (
    <div className="flex min-h-[85vh] flex-col items-start justify-center px-5 lg:px-10" data-testid="not-found-page">
      <Roundel className="h-20 w-20" />
      <h1 className="h-condensed mt-10 text-[clamp(4rem,14vw,10rem)]">404</h1>
      <p className="h-serif mt-2 text-[clamp(1.5rem,3.5vw,2.75rem)]">Page not found</p>
      <Link to="/" data-testid="not-found-home-link" className="link-arrow mt-10 text-xs">
        Back to home
        <CircledArrow className="h-5 w-5" />
      </Link>
    </div>
  );
}
